import { WWW_BASE_URL } from './env'
export const site = {
  title: 'Custodia Bank',
  host: WWW_BASE_URL,
  description:
    'Custodia provides a full suite of banking and financial services tailored to business customers looking for enhanced regulatory clarity, defined asset and balance sheet status for assets, and minimized transactional risk as they traverse the digital asset frontier.',
}
